import * as API from '../api/api'
const state = {
  fileUrl: ``,//文件路径
}
const mutations = {
  setMutations(state, data) {
    let keys = Object.keys(data)
    keys.map(item => {
      state[item] = data[item]
    })
  },
  setFileUrl(state, data) {
    state.fileUrl = data
  }
}
const actions = {
  fetchUserAuth({
    commit,
    dispatch
  }) {
    fetch('https://szshsurvey.com/smc_resource/json/lyc/info.json').then(d => {
      d.json().then(res => {
        return new Promise((resolve, reject) => {
          API.getUserAuth({ userName: res.userName, password: res.password })
            .then(res => {
              resolve(res)
            })
        })
      })
    })

  }
}
export default {
  namespaced: true,
  state,
  actions,
  mutations
}
